import React from "react";
import styled from "styled-components";
import { Caption2 } from "../styles/typography";
import OptionCard from "./OptionCard";

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ErrorMessage = styled(Caption2)`
  color: rgb(${(props) => props.theme.colors.error400});
  margin: 2px 4px;
`;

/**
 * @param {{
 *  options: {id:string,label:string,description?:string,imageUrl?:string}[],
 *  value: string|string[],
 *  onChange: (value:string|string[])=>void,
 *  multiSelect?: boolean,
 *  errorCondition?: boolean,
 *  errorMessage?: string,
 *  showBgImage?:boolean
 * }} props
 */
const OptionGrid = ({
  options,
  value,
  onChange,
  multiSelect = false,
  errorCondition,
  errorMessage,
  style,
  showBgImage,
}) => {
  const selectedValues = multiSelect ? value ?? [] : value;

  const handleSelect = (id) => {
    if (!multiSelect) {
      onChange(id);
      return;
    }
    const current = value ?? [];
    if (current.includes(id)) {
      onChange(current.filter((v) => v !== id));
    } else {
      onChange(current.concat(id));
    }
  };

  return (
    <div style={style}>
      <Grid>
        {options.map((option) => (
          <OptionCard
            key={option.id}
            id={option.id}
            label={option.label}
            description={option.description}
            imageUrl={option.imageUrl}
            selected={
              multiSelect
                ? selectedValues.includes(option.id)
                : selectedValues === option.id
            }
            onSelect={handleSelect}
          />
        ))}
      </Grid>
      {errorCondition && errorMessage && (
        <ErrorMessage>{errorMessage}</ErrorMessage>
      )}
    </div>
  );
};

export default OptionGrid;
